// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Kp441TeCLl8qWHap3DFm{background:var(--background-neutral-subtle);border-radius:6px;grid-template-columns:1fr 1fr;display:grid}.Kp441TeCLl8qWHap3DFm .fFGj5jWDJloyt_vBQGRI{color:var(--content-primary-tertiary);align-items:center;gap:4px;padding:12px 8px;display:flex}._G9qGKyXJRUvt4n4iWO8{grid-template-columns:1fr 1fr;gap:16px;display:grid}._G9qGKyXJRUvt4n4iWO8 .fFGj5jWDJloyt_vBQGRI{padding-top:12px;padding-bottom:12px}._G9qGKyXJRUvt4n4iWO8:not(:last-child){border-bottom:1px solid var(--border-neutral-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Kp441TeCLl8qWHap3DFm`,
	"cell": `fFGj5jWDJloyt_vBQGRI`,
	"item": `_G9qGKyXJRUvt4n4iWO8`
};
export default ___CSS_LOADER_EXPORT___;
